import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 max-w-screen-2xl mx-auto">
      <div className="relative rounded-xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20soft%20gradient%20of%20peach%20and%20cream%20tones%2C%20delicate%20floating%20particles%2C%20elegant%20minimal%20composition%2C%20cinematic%20wide%20format%2C%20dreamy%20and%20inviting%20mood&width=1600&height=500&seq=sakura-cta-bg&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>

        <div className="relative z-10 py-14 md:py-20 px-6 md:px-12 text-center">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            立即开始您的观影之旅
          </h2>
          <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-8">
            樱花视频汇集<strong>91视频</strong>、<strong>97视频</strong>、<strong>51视频</strong>等海量影视资源，高清流畅不卡顿，随时随地畅享精彩内容
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            {categories.slice(0, 3).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-6 py-3 bg-white text-foreground-950 rounded-md font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/90 transition-colors"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}